import React from "react";

/**
 * Doctors pattern, packaged:
 * - Mobile: carousel rail only
 * - Desktop: stacked first N + carousel for the rest
 *
 * Props:
 *  - items: array
 *  - renderCard: (item) => <Card />
 *  - onSelect: (item) => void
 *  - stackCount: number (default 3)
 */
export default function AppointmentsResultsRail({
  items = [],
  renderCard,
  onSelect,
  stackCount = 3,
}) {
  const list = Array.isArray(items) ? items : [];

  const desktopStack = list.slice(0, stackCount);
  const desktopRest = list.slice(stackCount);

  return (
    <>
      {/* ✅ Desktop (ONLY) */}
      <div className="hidden md:block">
        {/* Stack */}
        <div className="max-h-[42vh] overflow-y-auto no-scrollbar pb-2">
          <div className="space-y-4">
            {desktopStack.map((item) => (
              <div
                key={item.id}
                onClick={() => onSelect?.(item)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onSelect?.(item);
                  }
                }}
                className="w-full text-left"
                role="button"
                tabIndex={0}
                aria-label={`Select ${item?.name ?? "item"}`}
              >
                {renderCard(item)}
              </div>
            ))}
          </div>
        </div>

        {/* Rest carousel */}
        {desktopRest.length > 0 && (
          <div className="mt-4">
            <div className="flex gap-4 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-2">
              {desktopRest.map((item) => (
                <div
                  key={item.id}
                  onClick={() => onSelect?.(item)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      onSelect?.(item);
                    }
                  }}
                  className="snap-start shrink-0 w-[520px] text-left"
                  role="button"
                  tabIndex={0}
                  aria-label={`Select ${item?.name ?? "item"}`}
                >
                  {renderCard(item)}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* ✅ Mobile (ONLY) */}
      <div className="md:hidden mt-2">
        <div className="flex gap-4 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-2">
          {list.map((item) => (
            <div
              key={item.id}
              onClick={() => onSelect?.(item)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onSelect?.(item);
                }
              }}
              className="snap-start shrink-0 w-[92%] text-left"
              role="button"
              tabIndex={0}
              aria-label={`Select ${item?.name ?? "item"}`}
            >
              {renderCard(item)}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
